import axios from "axios";
import { useRef } from "react";
import { useContext } from "react";
import constants from "../../constants";
import WebSocketHooks from "../WebSocketHooks";
import { getDataFromStorage } from "../../util";
import AlertContext from "../../context/AlertContext";
import useCommonFunctionHooks from "../useCommonFunctionHooks";
import useS3FileManagement from "../useS3FileManagement";

export default function MobileViewSetUpHooks() {
  const Alert = useContext(AlertContext);

  const { wsRef } = WebSocketHooks();
  const { onUploadS3Object } = useS3FileManagement();
  const { getCatchBlockDetails } = useCommonFunctionHooks();

  const status = parseInt(getDataFromStorage("status"));

  const pathName = () => {
    if (process.env?.REACT_APP_MOBILE_NODE_API?.includes("ngrok-free.app") || process.env?.REACT_APP_MOBILE_NODE_API?.includes("trycloudflare.com")) {
      return process.env.REACT_APP_MOBILE_NODE_API;
    } else {
      return process.env.REACT_APP_NODE_API;
    }
  };

  const folderName = () => {
    if (
      process.env?.REACT_APP_MOBILE_NODE_API?.includes("trycloudflare.com") ||
      process.env?.REACT_APP_MOBILE_NODE_API?.includes("ngrok-free.app")
    ) {
      return "dev";
    } else {
      return "prod";
    }
  };

  const picRef = useRef(null);
  const WebSocketRef = useRef(false);

  const videoConstraints = {
    facingMode: "user",
    aspectRatio: 16 / 9,
    width: { ideal: 1920 },
    height: { ideal: 1080 },
  };

  // // Helper function to convert base64 data URL to Blob
  // const dataURLtoBlob = (dataURL) => {
  //   try {
  //     const arr = dataURL.split(',');
  //     const mime = arr[0].match(/:(.*?);/)[1];
  //     const bstr = atob(arr[1]);
  //     let n = bstr.length;
  //     const u8arr = new Uint8Array(n);
      
  //     while (n--) {
  //       u8arr[n] = bstr.charCodeAt(n);
  //     }
      
  //     return new Blob([u8arr], { type: mime });
  //   } catch (error) {
  //     console.error("Error converting dataURL to Blob:", error);
  //     throw new Error("Failed to convert image to uploadable format");
  //   }
  // };

  // // Helper function to rotate image based on orientation
  // const rotateImage = (dataURL, degrees) => {
  //   return new Promise((resolve) => {
  //     const img = new Image();
  //     img.onload = () => {
  //       const canvas = document.createElement('canvas');
  //       const ctx = canvas.getContext('2d');
        
  //       // Swap width/height for 90 or 270 degree rotation
  //       if (degrees === 90 || degrees === 270) {
  //         canvas.width = img.height;
  //         canvas.height = img.width;
  //       } else {
  //         canvas.width = img.width;
  //         canvas.height = img.height;
  //       }
        
  //       // Rotate around center
  //       ctx.translate(canvas.width / 2, canvas.height / 2);
  //       ctx.rotate((degrees * Math.PI) / 180);
  //       ctx.drawImage(img, -img.width / 2, -img.height / 2);
        
  //       resolve(canvas.toDataURL('image/jpeg', 0.95));
  //     };
  //     img.src = dataURL;
  //   });
  // };

  // // Detect device orientation
  // const getDeviceOrientation = () => {
  //   // Check screen orientation API
  //   if (window.screen?.orientation?.angle !== undefined) {
  //     return window.screen.orientation.angle;
  //   }
    
  //   // Fallback to window orientation
  //   if (window.orientation !== undefined) {
  //     return Math.abs(window.orientation);
  //   }
    
  //   // Last resort: compare width vs height
  //   return window.innerWidth > window.innerHeight ? 90 : 0;
  // };

  const validateToken = () => {
    axios
      .post(
        `${pathName()}node/learner/dp/validate`,
        JSON.stringify({
          userId: getDataFromStorage("userId"),
          token: localStorage.getItem("tokenKey"),
        }),
        {
          timeout: 60000,
          headers: {
            Authorization: "abdjcdifouvn",
            "Content-type": "application/json",
          },
        }
      )
      .then((res) => {
        if (res.data.resultCode === constants.RESULT_STATUS.SUCCESS) {
          if (res.data?.data?.token) {
            localStorage.setItem("tokenKey", res.data.data.token);
          }
        } else {
          Alert.setShowNotify({
            show: true,
            title: "Warning",
            msg: res.data.msg,
            primaryButtonFunction: () =>
              (window.location.href = "https://gradious.com/"),
          });
        }
      })
      .catch((error) => {
        getCatchBlockDetails(error);
      });
  };

  const saveDpPics = (fileName) => {
    axios
      .post(
        `${pathName()}node/learner/dp/pics/save`,
        JSON.stringify({
          fileName,
          qnId: getDataFromStorage("qnId"),
          userId: getDataFromStorage("userId"),
          testId: getDataFromStorage("testId"),
        }),
        {
          timeout: 60000,
          headers: {
            Authorization: "abdjcdifouvn",
            "Content-type": "application/json",
          },
        }
      )
      .then((res) => {
        if (res.data.resultCode === constants.RESULT_STATUS.SUCCESS) {
          if (res.data?.data?.token) {
            localStorage.setItem("tokenKey", res.data.data.token);
          }
        } else {
          Alert.setShowNotify({
            show: true,
            title: "Warning",
            msg: res.data.msg,
          });
        }
      })
      .catch((error) => {
        getCatchBlockDetails(error);
      });
  };

  // const captureAndUploadImage = async () => {
  //   try {
  //     let pictureSrc = picRef?.current?.getScreenshot();

  //     if (!pictureSrc) {
  //       console.error("Failed to capture image");
  //       Alert.setShowNotify({
  //         show: true,
  //         title: "Capture Failed",
  //         msg: "Unable to capture image from camera.",
  //       });
  //       return;
  //     }

  //     // Validate it's a proper data URL
  //     if (!pictureSrc.startsWith('data:image/')) {
  //       console.error("Invalid image format");
  //       throw new Error("Invalid image format captured");
  //     }

  //     // Get device orientation and rotate to landscape if needed
  //     const orientation = getDeviceOrientation();
  //     console.log("Device orientation:", orientation, "degrees");
      
  //     // Default is landscape - rotate portrait images to landscape
  //     if (orientation === 0) {
  //       console.log("Converting portrait to landscape (rotating 90 degrees)");
  //       pictureSrc = await rotateImage(pictureSrc, 90); // Portrait to landscape
  //     } else if (orientation === 180) {
  //       console.log("Converting upside-down portrait to landscape (rotating 270 degrees)");
  //       pictureSrc = await rotateImage(pictureSrc, 270); // Upside-down portrait to landscape
  //     }
  //     // Landscape orientations (90° and 270°) are kept as-is
  //     console.log("Image orientation set to landscape");

  //     // Set for preview (keep as base64)
  //     Alert.setVerifyImg(pictureSrc);

  //     const timestamp = Date.now();
  //     const filePath = generateFilePath(timestamp);

  //     console.log("Uploading image to:", filePath);

  //     // Convert base64 to Blob before uploading
  //     const imageBlob = dataURLtoBlob(pictureSrc);
  //     console.log("Converted to Blob:", imageBlob.type, imageBlob.size, "bytes");

  //     // Upload the Blob
  //     await onUploadS3Object(filePath, imageBlob, "png", "DP");

  //     console.log("Image uploaded successfully to:", filePath);

  //     // Save to database if needed
  //     if (status === 2) {
  //       saveDpPics(`${timestamp}.png`);
  //     }

  //     // Send WebSocket notification
  //     sendWebSocketNotification(filePath, timestamp);

  //     return { success: true, filePath };

  //   } catch (error) {
  //     console.error("Error in captureAndUploadImage:", error);
  //     Alert.setShowNotify({
  //       show: true,
  //       title: "Upload Failed",
  //       msg: "Failed to upload image. Please check your connection and try again.",
  //     });
  //     throw error;
  //   }
  // };

// Generate file path based on status
  
const captureAndUploadImage = async () => {
  try {
    let pictureSrc = picRef?.current?.getScreenshot();

    if (!pictureSrc) {
      console.error("Failed to capture image");
      Alert.setShowNotify({
        show: true,
        title: "Capture Failed",
        msg: "Unable to capture image from camera.",
      });
      return;
    }

    // Validate it's a proper data URL
    if (!pictureSrc.startsWith('data:image/')) {
      console.error("Invalid image format");
      throw new Error("Invalid image format captured");
    }

   
    const rotatedImg = await rotateBase64Image(pictureSrc);
    
    // Set for preview
    Alert.setVerifyImg(rotatedImg);

    const timestamp = Date.now();
    const filePath = generateFilePath(timestamp);

    console.log("Uploading image to:", filePath);

    // Convert base64 to Blob before uploading (using the same approach as old code)
    const imageBlob = await b64toBlob(rotatedImg);
    console.log("Converted to Blob:", imageBlob.type, imageBlob.size, "bytes");

    // Upload the Blob
    await onUploadS3Object(filePath, imageBlob, "png", "DP");

    console.log("Image uploaded successfully to:", filePath);

    // Save to database if needed
    if (status === 2) {
      saveDpPics(`${timestamp}.png`);
    }

    // Send WebSocket notification
    sendWebSocketNotification(filePath, timestamp);

    return { success: true, filePath };

  } catch (error) {
    console.error("Error in captureAndUploadImage:", error);
    Alert.setShowNotify({
      show: true,
      title: "Upload Failed",
      msg: "Failed to upload image. Please check your connection and try again.",
    });
    throw error;
  }
};

// Use the exact same rotation function from old code
const rotateBase64Image = (base64Image) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.src = base64Image;

    img.onload = () => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      canvas.width = img.height;
      canvas.height = img.width;

      ctx.translate(canvas.width / 2, canvas.height / 2);
      ctx.rotate((-90 * Math.PI) / 180);
      ctx.drawImage(img, -img.width / 2, -img.height / 2);

      const rotatedBase64 = canvas.toDataURL("image/jpeg");
      resolve(rotatedBase64);
    };
  });
};

// Use the exact same blob conversion from old code
const b64toBlob = (dataURI) => {
  return new Promise((resolve, reject) => {
    try {
      let byteString = atob(dataURI.split(",")[1]);
      let ab = new ArrayBuffer(byteString.length);
      let ia = new Uint8Array(ab);

      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }

      let blobdata = new Blob([ab], { type: "image/png" });
      resolve(blobdata);
    } catch (err) {
      reject(err);
    }
  });
};

const generateFilePath = (timestamp) => {
    if (status === 2) {
      const isCodingChallenge = parseInt(getDataFromStorage("libType")) === constants.libTypeIds.CODING_CHALLENGE;
      
      if (isCodingChallenge) {
        return `${folderName()}/proctoring/${getDataFromStorage("testId")}/${getDataFromStorage("qnId")}/${getDataFromStorage("userId")}/${timestamp}.png`;
      } else {
        return `${folderName()}/proctoring/${getDataFromStorage("testId")}/${getDataFromStorage("userId")}/${timestamp}.png`;
      }
    } else {
      return `${folderName()}/setup/${getDataFromStorage("userId")}.png`;
    }
};

// Send WebSocket notification
const sendWebSocketNotification = (filePath, timestamp) => {
  const message = JSON.stringify({
    filePath,
    type: constants.WEBSOCKET.VERIFY_PIC,
    timestamp,
  });

  if (!WebSocketRef.current) {
    if (wsRef.current?.readyState === WebSocket.OPEN) {
      wsRef.current.send(message);
      console.log("✅ WebSocket message sent:", message);
    } else {
      wsRef.current?.addEventListener("open", () => {
        wsRef.current.send(message);
        console.log("✅ WebSocket message sent after connection:", message);
      }, { once: true });
    }
    WebSocketRef.current = true;
  }
};

  return {
    picRef,
    pathName,
    folderName,
    validateToken,
    videoConstraints,
    captureAndUploadImage,
  };
}
